import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=0af470db"
import script from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports